import { makeAutoObservable } from "mobx";

export interface IEditorState {
    editing: boolean;
    loading: boolean;
}

export class EditorState implements IEditorState {
    editing = false;
    loading = false;

    constructor(editing?: boolean) {
        makeAutoObservable(this);

        if (editing) {
            this.editing = editing;
        }
    }

    setEditing(editing: boolean) {
        this.editing = editing;
    }

    setLoading(loading: boolean) {
        this.loading = loading;
    }
}